import { AssistChip, Box, Toast, useToast } from '@zillow/constellation-10';
import { IconMailFilled, IconPhoneFilled } from '@zillow/constellation-icons';
import { useContext } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useRenterProfileContactActionsDataQuery } from '../../../../types/GraphqlTypes';
import { ModalType } from '../../../../types/ModalType';
import {
  CONTACT_INFO_CALL_ICON_CLICK_EVENT_TYPE_ID,
  CONTACT_INFO_COPY_EMAIL_CLICK_EVENT_TYPE_ID,
  emitContactInfoCallIconClickEvent,
  emitContactInfoCopyEmailClickEvent,
} from '../../../../constants/clickstreamEvents/actionSidebar';
import useModal from '../../../../hooks/useModal';
import { InboxPageContext } from '../../../../contexts/InboxPageContextProvider';
import ContactInfoCallModal from '../../../Modals/ContactInfoCallModal';
import { useAuth } from '@zg-rentals/auth-comet';

export default function ContactActions(): JSX.Element | null {
  const { conversationId, listingAlias } = useContext(InboxPageContext);
  const { enqueueToast } = useToast();
  const { user } = useAuth();
  const { data: contactActionsData } = useRenterProfileContactActionsDataQuery({
    variables: {
      conversationId: conversationId!,
      listingAlias: listingAlias!,
    },
    fetchPolicy: 'cache-only',
  });
  const { activeModal, setActiveModal } = useModal();

  if (!contactActionsData) {
    return null;
  }

  const { inquiry, referenceEmail } = contactActionsData.ZRM_getConversationById;
  const name = inquiry?.name || '';
  const phoneNumber = inquiry?.phone || '';
  const shouldShowCallButton = Boolean(phoneNumber);
  const shouldShowEmailButton = Boolean(referenceEmail);

  const handleContactInfoCall = () => {
    setActiveModal(ModalType.ContactInfoCallModal);
    emitContactInfoCallIconClickEvent(user);
  };

  const handleCopyEmailClick = () => {
    enqueueToast(<Toast tone="success">Email copied</Toast>);
    emitContactInfoCopyEmailClickEvent(user);
  };

  return (
    <>
      {activeModal === ModalType.ContactInfoCallModal && <ContactInfoCallModal phone={phoneNumber} name={name} />}

      <Box
        css={{ display: 'flex', alignItems: 'center', alignSelf: 'stretch', justifyContent: 'center', gap: 'tight' }}
      >
        {shouldShowCallButton && (
          <AssistChip
            data-eventid={CONTACT_INFO_CALL_ICON_CLICK_EVENT_TYPE_ID}
            aria-haspopup="dialog"
            onClick={handleContactInfoCall}
            icon={<IconPhoneFilled />}
          >
            Call
          </AssistChip>
        )}

        {shouldShowEmailButton && (
          <CopyToClipboard onCopy={handleCopyEmailClick} text={referenceEmail || ''}>
            <AssistChip
              data-eventid={CONTACT_INFO_COPY_EMAIL_CLICK_EVENT_TYPE_ID}
              aria-haspopup="dialog"
              icon={<IconMailFilled />}
            >
              Email
            </AssistChip>
          </CopyToClipboard>
        )}
      </Box>
    </>
  );
}
